import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { convertNumberToUSFormat, downloadBlobFIle } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

const OrderSummeryReport = ({ show, handleClose }) => {
	const [margins, setMargins] = useState(null);
	const [ids, setIds] = useState([]);
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(openLoader());
		ApiClient.GET(`${BASE_URL}/order/${id}/margin-summary`, '', true)
			.then((response) => {
				let supplierIds = [];
				let rfqIds = [];
				if (response.data.projectedMarginDataList) {
					response.data.projectedMarginDataList.forEach((item) => {
						if (item.isSameSupplier === false && !supplierIds.includes(item.supplierId)) {
							supplierIds.push(item.supplierId);
							rfqIds.push(item.rfqId);
						}
					});
				}
				setIds(rfqIds);
				setMargins(response.data);
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	}, []);

	const handleDownload = () => {
		dispatch(openLoader());
		ApiClient.GET_FILE_DATA(`${BASE_URL}/order/${id}/report/margin-summary`, '', true)
			.then((response) => {
				downloadBlobFIle(response);
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	};

	const renderMargins = () => {
		return margins?.projectedMarginDataList?.map((item) => {
			let rowSpanNumber = item.isSameSupplier === false ? item.noOfSameSupplier : 0;
			return (
				<tr key={`item_${item.rfqId}`}>
					{ids.includes(item.rfqId) && <td rowSpan={rowSpanNumber}>{item.supplierName}</td>}
					{!('noOfSameSupplier' in item) && <td></td>}
					<td>{item.referenceNumber}</td>
					<td>{item?.poNumber}</td>
					<td>
						<span className="gray_dark_02">
							{convertNumberToUSFormat(item?.poQuantity, true)}
						</span>
					</td>
					<td>
						{Math.sign(item.poValue) === -1 ? '- ' : ''}
						{item?.poValue > 0 ? '$' : ''}
						{convertNumberToUSFormat(Math.abs(item.poValue))}
					</td>
					<td>
						{Math.sign(item.factoryCost) === -1 ? '- ' : ''}
						{item?.factoryCost > 0 ? '$' : ''}
						{convertNumberToUSFormat(Math.abs(item.factoryCost))}
					</td>
					<td>
						{Math.sign(item.marginValue) === -1 ? '- ' : ''}
						{item?.marginValue > 0 ? '$' : ''}
						{convertNumberToUSFormat(Math.abs(item.marginValue))}
					</td>
					<td>
						{convertNumberToUSFormat(item.marginPercentage)}
						{item?.marginPercentage > 0 ? '%' : ''}
					</td>
				</tr>
			);
		});
	};

	return (
		<Modal show={show} onHide={handleClose} centered={true}>
			<Modal.Body>
				<div className="popup-wrapper">
					<div className="common-popup width-784 order-margin-summary-popup body-scroll shadow-24dp">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Order margin summary (Projected)</h3>
							</div>
							<div className="close-btn" onClick={handleClose}>
								<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
							</div>
						</div>
						<div className="common-popup-body scroll-y-label">
							<table className="table with-border no-hover">
								<thead>
									<tr>
										<th>Factory</th>
										<th>Style({margins?.projectedMarginDataList?.length})</th>
										<th>PO Number</th>
										<th>PO Qty</th>
										<th>PO value</th>
										<th>Factory cost</th>
										<th>Margin</th>
										<th>Margin(%)</th>
									</tr>
								</thead>
								<tbody>
									{renderMargins()}
									<tr>
										<td></td>
										<td></td>
										<td>Total</td>
										<td>{convertNumberToUSFormat(margins?.totalPoQuantity, true)}</td>
										<td>
											{Math.sign(margins?.totalPoValue) === -1 ? '- ' : ''}
											{margins?.totalPoValue > 0 ? '$' : ''}
											{convertNumberToUSFormat(Math.abs(margins?.totalPoValue), true)}
										</td>
										<td>
											{Math.sign(margins?.totalFactoryCost) === -1 ? '- ' : ''}
											{margins?.totalFactoryCost > 0 ? '$' : ''}
											{convertNumberToUSFormat(
												Math.abs(margins?.totalFactoryCost),
												true
											)}
										</td>
										<td>
											{Math.sign(margins?.totalMarginValue) === -1 ? '- ' : ''}
											{margins?.totalMarginValue > 0 ? '$' : ''}
											{convertNumberToUSFormat(
												Math.abs(margins?.totalMarginValue),
												true
											)}
										</td>
										<td>
											{margins?.averageMarginPercentage
												? convertNumberToUSFormat(margins?.averageMarginPercentage) +
													'%'
												: ''}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div className="common-popup-footer px-4 pb-3">
							<div className="mt-3 text-right">
								<button className="button gray-outline size32 ml-2" onClick={handleDownload}>
									<img
										src={`${process.env.PUBLIC_URL}/icons/download-dark-20.svg`}
										alt=""
									/>{' '}
									Download
								</button>
							</div>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default OrderSummeryReport;
